export default __webpack_public_path__ + "static/media/foto1.fd351994.jpg";